import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./dashboard/layouts/layout"; // Fixed capitalization
import LandingPage from "./pages/LandingPage";
import MigratePage from "./pages/MigratePage";
import IngestionPage from "./pages/IngestionPage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Payment from "./pages/Payment";
import PublicRoute from "./utils/PublicRoute";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProtectedRoute from "./utils/ProtectedRoute";
import UserJobs from "./pages/UserJobs";
import SuccessPage from "./pages/SuccessPage";
import FailurePage from "./pages/FailurePage";
import MigrationJobs from "./pages/MigrationJobs";
import MigrationJobStatus from "./pages/MigrationJobStatus";
import MigrationInsights from "./pages/MigrationInsights";
import PineconeVsQdrant from "./pages/comparison pages/PineconeVsQdrant";
import FQAPage from "./pages/FQAPage";
import QdrantVsWeaviate from "./pages/comparison pages/QdrantVsWeaviate";
import ChromaVsPinecone from "./pages/comparison pages/ChromaVsPinecone";
import WeaviateVsPinecone from "./pages/comparison pages/WeaviateVsPinecone";
import Analytics from "./dashboard/pages/Analytics";
import QdrantVsMilvus from "./pages/comparison pages/QdrantVsMilvus";
import WeaviateVsMilvus from "./pages/comparison pages/WeaviateVsMilvus";
import ChromaVsMilvus from "./pages/comparison pages/ChromaVsMilvus";
// Import dashboard pages
import Overview from "./dashboard/pages/Overview";
import Migrations from "./dashboard/pages/Migration";
import Settings from "./dashboard/pages/Settings";
import Integrations from "./dashboard/pages/Integrations";
import HelpSupport from "./dashboard/pages/Support";
import MigrationFlow from "./pages/Migrationpaths";
// Placeholder components for other dashboard routes


function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/faq" element={<FQAPage />} />
      <Route path="/migrations" element={<MigrationFlow />} />
      <Route
        path="/comparisons/pinecone-vs-qdrant"
        element={<PineconeVsQdrant />}
      />
      <Route
        path="/comparisons/qdrant-vs-weaviate"
        element={<QdrantVsWeaviate />}
      />
      <Route
        path="/comparisons/chroma-vs-pinecone"
        element={<ChromaVsPinecone />}
      />
      <Route
        path="/comparisons/weaviate-vs-pinecone"
        element={<WeaviateVsPinecone />}
      />
      <Route
  path="/comparisons/qdrant-vs-milvus"
  element={<QdrantVsMilvus />}
/>

<Route
  path="/comparisons/weaviate-vs-milvus"
  element={<WeaviateVsMilvus/>}
/>

<Route
  path="/comparisons/chroma-vs-milvus"
  element={<ChromaVsMilvus />}
/>

      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/migration-insights" element={<MigrationInsights />} />
      <Route path="/payment-success/:job_id" element={<SuccessPage />} />
      <Route path="/payment-cancel/:job_id" element={<FailurePage />} />
      <Route path="/migration/jobs" element={<MigrationJobs />} />
      <Route path="/migration/job/:jobId" element={<MigrationJobStatus />} />

      {/* Auth Routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <Signup />
          </PublicRoute>
        }
      />

      {/* Protected Routes */}
      <Route
        path="/migrate"
        element={
          <ProtectedRoute>
            <MigratePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-jobs/:user_id"
        element={
          <ProtectedRoute>
            <UserJobs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ingestion"
        element={
          <ProtectedRoute>
            <IngestionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payments"
        element={
          <ProtectedRoute>
            <Payment />
          </ProtectedRoute>
        }
      />

      {/* Dashboard Routes with Nested Pages */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Dashboard nested routes */}
        <Route index element={<Overview />} />
        <Route path="migrations" element={<Migrations />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="help" element={<HelpSupport />} />
      </Route>

      {/* 404 Route */}
      <Route
        path="*"
        element={
          <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-6xl font-bold text-white mb-4">404</h1>
              <p className="text-gray-400 mb-4">Page not found</p>
              <a
                href="/"
                className="text-blue-400 hover:text-blue-300 underline"
              >
                Go to Home
              </a>
            </div>
          </div>
        }
      />
    </Routes>
  );
}

export default App;